module.exports = __webpack_public_path__ + "img/cockpit1.19725534.png";